import { ReactElement, useMemo } from "react";
import { ValidGlobalSearchItemPersistedModel } from "../../Persistence/validation";
import { GlobalSearchResultItemKind } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { SearchListItem } from "client/Features/Search/SearchListItem";
import { generateTrackingId, isNotNil } from "client/Misc/utils";
import { UserIdentityModel } from "client/Api/UserProfile/service";
import { CommunityPostListItem } from "client/Features/Layout/TitleBar/GlobalSearch/Items/CommunityPostListItem";
import { TimeZone } from "client/DateAndTime/timezones";
import { useCommunityPostNavigationHandler } from "client/Features/Layout/TitleBar/GlobalSearch/Navigation/useCommunityPostNavigationHandler";
import { convertUserIdentityModel } from "../../Persistence/convertPersistedData";

export type CommunityPostItemViewProps = {
	item: ValidGlobalSearchItemPersistedModel<GlobalSearchResultItemKind.CommunityPost>;
	navigationIndex: number;
	onRemove: () => void;
	timezone: TimeZone;
};

export const CommunityPostItemView = (props: CommunityPostItemViewProps): ReactElement => {
	const {
		item,
		navigationIndex,
		onRemove,
		timezone
	} = props;

	const {
		communityName,
		createdBy: persistedCreatedBy,
		createdOn,
		id,
		messagePreview
	} = item.communityPost;

	const createdBy = useMemo(
		(): UserIdentityModel | null => isNotNil(persistedCreatedBy)
			? convertUserIdentityModel(persistedCreatedBy)
			: null,
		[persistedCreatedBy]
	);

	const executeHandler: () => void = useCommunityPostNavigationHandler({
		id,
		recentlyOpenedItem: item
	});

	return (
		<SearchListItem
			onExecute={executeHandler}
			trackingId={generateTrackingId("community-post-item", `|${id}`)}
		>
			<CommunityPostListItem
				id={id}
				communityName={communityName}
				createdBy={createdBy}
				createdOn={createdOn}
				messagePreview={messagePreview}
				onRemove={onRemove}
				timezone={timezone}
				itemIndex={navigationIndex}
				tabIndex={-1}
				onExecute={executeHandler}
			/>
		</SearchListItem>
	);
};
CommunityPostItemView.displayName = "CommunityPostItemView";